define(
    [
        'core/urls',
        'moment',
        'core/browser-storage',
        'components/modal',
        'components/fake-progress',
        'components/dropdown',
        'components/request-time-manager',
        'core/iterate',
        'components/pagination',
        'components/search-field',
        'components/custom-encode-uri',
        'components/metrics',
        'components/automation-banner',
        'core/utilities',
    ],
    function (
        urls, 
        moment, 
        browser_storage, 
        modal, 
        FakeProgress, 
        DD, 
        requestTM,
        iterate,
        initPagination, 
        initSearchField,
        customEncodeUri,
        keyMetrics,
        automationBanner,
        utilities
    ) 
    {
        let nodes = {
            main: document.querySelector(".sb-page.survey-results"),
            globalMetrics: document.querySelector(".metrics-header-wrap.global"),
            globalMetricsHeader: document.querySelector(".metrics-header-wrap.global header"),
            categoryMetrics: document.querySelector(".metrics-header-wrap.categories"),
            categoryMetricCards: document.querySelector(".metrics-header-wrap.categories .cards"),
            responsesHeader: document.querySelector(".page-header.responses"),
            surveySelector: document.querySelector(".survey-selector"),
            surveySelectorOptions: document.querySelectorAll(".survey-selector option"),
            settingsToggle: document.querySelector(".settings-toggle-wrap"),
            noSurveysWrap: document.querySelector(".no-results"),
            filterSettings: document.querySelector(".settings-panel.filter-settings"),
            filterSettingsToggle: document.querySelector(".settings-toggle-wrap"),
            filterSettingsToggleLabel: document.querySelector(".settings-toggle-wrap .label"),
            filtersReset: document.querySelector(".reset-settings"),
            loaderElement: document.querySelector(".marketing-loader"),
            loaderHint: document.querySelector(".marketing-loader .loader-bar-wrap_hint"),
            responsesBody: document.querySelector(".responses-table tbody"),
            resultsWrapper: document.querySelector(".responses-wrapper"),
            noResultsWrapper: document.querySelector(".no-responses"),
            resultsTable: document.querySelector(".contacts-table"),
            tableResultsWrap: document.querySelector(".table-results-wrap"),
            searchField: {
                searchField: document.querySelector(".search-response_js"),
                resetBtn: document.querySelector(".search-response-reset_js"),
                openBtn: document.querySelector(".search-response-open_js"),
                wrap: document.querySelector(".results-search-wrap_js")
            },
            pagination: {
                wrap: document.querySelector(".pagination_js"),
                page: document.querySelector(".pagination_page_js"),
                hole: document.querySelector(".pagination_hole_js")
            },
            metrics: {
                main: document.querySelector(".metrics-header-wrap.global"),
                wrap: document.querySelector(".metrics-wrap"),
                metricsContainer: document.querySelector(".metrics-wrap .metrics"),
                header: document.querySelector(".page-header.metrics"),
            },
            modals: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    document.querySelector(".nps-responses"),
                    document.querySelector(".sidebar-nav"),
                    document.querySelector(".navigation-top")
                ]
            },
        };

        let createdModal = modal.create(nodes.modals, function () {});

        let metrics = keyMetrics.init(nodes.metrics, "survey-results");
        window.addEventListener("resize", metrics.adjustMetricsHeight);

        let currentSurvey = '';
        let pagination; 
        let isGlobal = false;
        let isAdmin = nodes.main.dataset.admin;

        let initialQueryParams = {
            q: "",
            limit: 10,
            page: 1,
            triggers: [],      
            contacts: [],
            companies: [],
            projects: [],
            comments: "",
            sort: {
                field: "date",
                value: null,
                direction: "desc"        
            }
        }

        let queryParams = JSON.parse(JSON.stringify(initialQueryParams));

        let filterNameMapping = {
            contacts: {
                plural: "Contacts",
                singular: "Contact",
            },
            triggers: {
                plural: "Survey Periods",
                singular: "Survey Period",
            },
            companies: {
                plural: "Companies",
                singular: "Company",
            },
            projects: {
                plural: "Projects",
                singular: "Project",
            },
            comments: {
                plural: "Responses",
                singular: "Comment",
            }
        }

        let loadingScreen = new FakeProgress(
            document.querySelector(".marketing-loader .loader-bar-wrap-bar")
        );

        const setSettingsHeight = (isPageLoad) => {
            let isHidden = nodes.filterSettings.classList.contains("hide");
            //disable transitions while adjusting height value
            nodes.filterSettings.classList.add("no-transition");
            // momentarily show and save settings height so hide transition works
            nodes.filterSettings.classList.remove("hide");
            nodes.filterSettings.style.height = null;
            let settingsHeight = nodes.filterSettings.offsetHeight;
            nodes.filterSettings.style.height = `${settingsHeight}px`;

            if(isPageLoad || isHidden) {  // don't override user's open/close settings
                nodes.filterSettings.classList.add("hide");
            }
            
            setTimeout(() => {
                nodes.filterSettings.classList.remove("no-transition");
            }, 1500);
        }

        let populateKeyMetrics = (keyMetrics) => {
            let metricsElements = {
                average: nodes.globalMetrics.querySelectorAll(".project-score .value"),
                surveys_sent: nodes.globalMetrics.querySelectorAll(".surveys-sent .value"),
                collected_responses: nodes.globalMetrics.querySelectorAll(".responses .value"),
                response_rate: nodes.globalMetrics.querySelectorAll(".response-rate .value"),
            }

            for (const property in metricsElements) {
                metricsElements[property].forEach(element => {
                    let scoreRounded = Math.round(keyMetrics[property] * 10) / 10;
                    if(property === 'average') {
                        let scoreSentiment = utilities.generateSentiment("projects", keyMetrics[property]);
                        element.classList.remove("positive", "neutral", "negative");
                        if(scoreSentiment) element.classList.add(scoreSentiment);
                    }
                    element.innerText = scoreRounded;
                })
            }
        }

        let createTableEventListeners = () => {
            nodes.resultsTable.querySelector("thead tr").addEventListener("click", (e) => {

                let el = e.target.parentElement;
                let key = el.getAttribute("data-id");

                if (key && el.classList.contains("sortable")) {
                    let isAsc = el.classList.contains("asc");
                    queryParams.sort.direction = isAsc ? 'desc' : 'asc';

                    if(el.classList.contains("category")) {
                        queryParams.sort.field = "category";
                        queryParams.sort.value = key * 1;
                    } else {
                        queryParams.sort.field = key;
                        queryParams.sort.value = null;
                    }
                    

                    getData(false, false, () => {
                        iterate(nodes.resultsTable.querySelectorAll(".sortable"), (node) => {
                            node.classList.remove("asc");
                            node.classList.remove("desc");
                            node.classList.remove("active");
                        });

                        el.classList.add("active");

                        if (queryParams.sort.direction === "asc") {
                            el.classList.add("asc");
                        } else {
                            el.classList.add("desc");
                        }
                    });
                }
            });
        }

        let populateTableHeader = (categories) => {
            let tableHeader = document.querySelector(".table-results-wrap table thead");
            let categoryElements = '';  

            categories.forEach(category => {
                categoryElements += `
                        <td class="score-column sortable category asc" data-id="${category.id}">
                            <span class="wrap-text">
                                ${category.name}
                                <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                            </span>
                        </td>
                    `;
            });

            let periodColumn = `
                <td class="period sortable asc" data-id="trigger">
                    <span class="wrap-text">
                        Survey Period <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                    </span>
                </td>
            `;

            let companyColumn = `
                <td class="company sortable asc" data-id="company">
                    <span class="wrap-text">
                        Company <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                    </span>
                </td>
            `;

            let projectColumn = `
                <td class="project sortable asc" data-id="project">
                    <span class="wrap-text">
                        Project <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                    </span>
                </td>
            `;

            let publishColumn = `
                <td class="publish-comment sortable asc" data-id="has_marketing_permissions">
                    <span class="wrap-text">
                        Publish Comment <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                    </span>
                </td>
            `;

            let deleteColumn = `
                <td class="delete-comment sortable asc" data-id="delete_response">
                    <span class="wrap-text">
                        Delete <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                    </span>
                </td>
            `;

            let customColumns = periodColumn;

            if(isGlobal) customColumns = companyColumn + projectColumn;

            tableHeader.innerHTML = `
                <tr>
                    <td class="name sortable asc" data-id="contact">
                        <span class="wrap-text">
                            Contact name <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                        </span>
                    </td>
                    <td class="date sortable active asc" data-id="date">
                        <span class="wrap-text">
                            Date <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                        </span>
                    </td>
                    ${customColumns}
                    ${categoryElements}
                    ${publishColumn}
                    ${deleteColumn}
                </tr>
            `;
            createTableEventListeners();
        }

        let populateCategoryMetrics = (categories) => {
            nodes.categoryMetricCards.innerHTML = '';
            categories.forEach(category => {
                let scoreRounded = (Math.round(category.average * 10) / 10);
                let sentiment = utilities.generateSentiment("projects", category.average);
                
                nodes.categoryMetricCards.innerHTML += `
                    <div class="card">
                        <div class="card__title">${category.name}</div>
                        <div class="card__main-score value ${sentiment}">${scoreRounded}</div>
                    </div>
                `;
            })
        }

        let populateResponses = (responses) => {
            nodes.responsesBody.innerHTML = '';
            let tableRows = '';

            responses.forEach((response, i) => {
                let evenOdd = (i % 2 === 0) ? 'even' : 'odd';
                let surveyPeriod = response.trigger.phase ? response.trigger.phase : "Project Status";
                let surveyPeriodStatus = response.trigger.status;
                let surveyPeriodOutput = `<div class="chip">${surveyPeriod}</div>
                                            <div class="chip">${surveyPeriodStatus}</div>`;
                
                let categoryScores = '';
                let commentRow = '';
                let colspan = isGlobal ? response.categories.length + 6 : response.categories.length + 5;
                let commentScoreTotal = 0;

                response.categories.forEach(category => {
                    let sentiment = utilities.generateSentiment("projects", category.value);
                    let categoryScore = category.value ? category.value : "—";
                    categoryScores += `<td class="center score-column"><div class="score ${sentiment}">${categoryScore}</div></td>`
                    commentScoreTotal += category.value;
                });

                if(response.comment && response.comment !== '') {
                    let truncateClass = '';
                    let moreLessElement = '';
                    if(response.comment.length > 100) {
                        truncateClass = "truncate";
                        moreLessElement = `<div class="show-comment">more</div>`
                    }

                    commentRow = `
                        <tr class="comment-row">
                            <td colspan="${colspan}" class="comment-row">
                                <div class="comment-wrap">
                                    <div class="comment ${truncateClass}">
                                        "${response.comment}"
                                    </div>
                                    ${moreLessElement}
                                </div>
                            </td>
                        </tr>
                    `;
                }

                let customColumns = `<td class="survey-period">${surveyPeriodOutput}</td>`;

                if(isGlobal) {
                    customColumns = `
                        <td class="company">${response.company}</td> 
                        <td class="project">${response.project}</td>    
                    `
                }

                let publishToggle = "-";
                if(Boolean(response.has_marketing_permissions)) {
                    let publishId = response.comment_response_id;
                    let checked = Boolean(response.is_published) ? "checked" : "";
                    let disabled = isAdmin === "True" ? "" : "disabled";

                    publishToggle = `
                        <div class="mini-toggle ${disabled}">
                            <input id="publishComment_${publishId}" class="publish-toggle" type="checkbox" data-response-id="${publishId}" ${checked}>
                            <label for="publishComment_${publishId}"></label>
                        </div>
                    `;
                }

                let publishComment = `
                    <td class="publish-comment">
                        ${publishToggle}
                    </td> `;

                let deleteButton = `
                    <td class="remove-response-wrap">
                        <div data-id="${response.deployment_id}" class="remove-response tooltip-wrap">
                            <div class="icon glyphicons glyphicons-remove-sign"></div>
                            <div class="sb-tooltip">
                                Removing a response will alter your Score and Response Rate
                            </div>
                        </div>  
                        <div data-id="${response.deployment_id}" class="remove-response-confirm hide">
                            Delete?
                            <div class="options">
                                <span data-id="${response.deployment_id}" class="yes">Yes</span>
                                <span data-id="${response.deployment_id}" class="no">No</span>
                            </div>
                        </div>
                    </td>
                `
                
                tableRows += `
                    <tr class="${evenOdd}" role="row" data-response-id=${response.comment_response_id} data-deployment-id="${response.deployment_id}">
                        <td class="name">${utilities.sanitizeData(response.contact.first_name)} ${utilities.sanitizeData(response.contact.last_name)}</td>
                        <td class="date">${moment(response.date).format('DD MMM YYYY')}</td>
                        ${customColumns}
                        ${categoryScores}
                        ${publishComment}
                        ${deleteButton}
                    </tr>
                    ${commentRow}
                `;
            })

            nodes.responsesBody.innerHTML = tableRows;

            nodes.responsesBody.querySelectorAll(".comment-wrap .show-comment").forEach(element => {
                element.addEventListener("click", (event) => {
                    let comment = event.target.previousElementSibling;

                    if(element.classList.contains("active")) {
                        element.classList.remove("active");
                        element.innerHTML = "more";
                        comment.classList.remove("open");
                        comment.classList.add("truncate");
                    } else {
                        element.classList.add("active");
                        element.innerHTML = "less";
                        comment.classList.add("open");
                        comment.classList.remove("truncate");
                    }
                })
            })

            nodes.responsesBody.querySelectorAll(".publish-comment input").forEach(input => {
                input.addEventListener("change", () => {
                    let publish = "false";
                    let id = input.dataset.responseId;

                    if(input.checked) {
                        publish = "true"
                    }

                    fetch(urls['projects:response_publish_toggle'](id), {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                        body: `publish=${publish}`
                    });
                })
            });

            nodes.responsesBody.querySelectorAll(".remove-response-wrap").forEach(el => {
                el.querySelector(".remove-response").addEventListener("click", (event) => {
                    event.currentTarget.classList.add("hide");
                    event.currentTarget.parentElement.querySelector(".remove-response-confirm").classList.remove("hide");
                });

                el.querySelector(".remove-response-confirm .yes").addEventListener("click", (event) => {
                    deleteResponse(event.target.getAttribute("data-id"));
                });
    
                el.querySelector(".remove-response-confirm .no").addEventListener("click", (event) => {
                    let id = event.target.getAttribute("data-id");
                    document.querySelector(`.remove-response[data-id="${id}"]`).classList.remove("hide");
                    document.querySelector(`.remove-response-confirm[data-id="${id}"]`).classList.add("hide");
                });
            });
        }

        let deleteResponse = (id) => {
            let row = document.querySelector(`tr[data-deployment-id="${id}"`);
            let commentRow = row.nextElementSibling && row.nextElementSibling.classList.contains("comment-row") ? row.nextElementSibling : null;
            row.classList.add("deleted");
            if(commentRow) commentRow.classList.add("deleted");
            
            fetch(urls["projects:response_delete"](id), {
                method: 'DELETE',
            }).then(() => {
                row.remove();
                if(commentRow) commentRow.remove();
                getData();
            })
        }

        let closeAllSelectors = (currentId) => {
            let selectors = document.querySelectorAll(".filter-wrap .selector.active");

            selectors.forEach(selector => {
                if(currentId) {
                    // exclude current selector if required
                    if(selector.getAttribute("data-id") !== currentId) {
                        selector.classList.remove("active");
                    }
                } else {
                    selector.classList.remove("active");
                }
            })
        }

        // deselect filter chip
        let deselectFilter = (filterId, categoryId) => {
            let filterWrap = document.querySelector(`.filter-wrap[data-id='${categoryId}']`);
            let filterSelections = filterWrap.querySelector(".selections");
            let selectionElement = filterSelections.querySelector(`[data-id='${filterId}']`);
            let filterOptionElement = filterWrap.querySelector(`.filter-options .option[data-id='${filterId}']`);
            let filterType = filterWrap.getAttribute("data-type");

            // deselect filter option in dropdown
            filterOptionElement.classList.remove("selected");

            // remove selection
            selectionElement.remove();

            // remove filter selection from params
            if(typeof queryParams[categoryId] === "string" || typeof queryParams[categoryId] === "number") {
                queryParams[categoryId] = "";
            } else {
                queryParams[categoryId] = queryParams[categoryId].filter(item => item !== decodeURIComponent(filterId));
            }

            // show the 'all' selection if no other filters selected
            if (!queryParams[categoryId].length) {
                filterSelections.querySelector(".selection.all").classList.remove("hide");
            }

            // re-activate filter option in dropdown
            filterWrap.querySelector(`.filter-options .option[data-id='${filterId}']`).classList.remove("selected");

            // updateFilterStatus();
            getData();
        }

        // toggle the filter selection in dropdown
        let toggleFilter = (chosenFilterElement, categoryId) => {
            let filterId = chosenFilterElement.getAttribute("data-id");
            let filterWrap = document.querySelector(`.filter-wrap[data-id='${categoryId}']`)
            let filterSelections = filterWrap.querySelector(".selections");

            // if user clicks a filter that is already selected - deselect it
            if (chosenFilterElement.classList.contains("selected")) {
                deselectFilter(filterId, categoryId)
                return;
            }
            
            // hide the 'all' state if not already hidden
            if (!queryParams[categoryId].length) {
                filterSelections.querySelector(".selection.all").classList.add("hide");
            }

            // comments is handled differently from other filters - it passes a single value, rather than array
            if(categoryId === "comments") {
                if(queryParams[categoryId] !== "") { 
                    // remove existing selection
                    filterWrap.querySelector(".filter-options .option.selected").classList.remove("selected");
                    filterSelections.querySelector(".selection").remove();
                }
                // update queryParams value to new selection
                queryParams[categoryId] = filterId * 1;
            } else {                
                // add selected filter to query params category array
                queryParams[categoryId].push(decodeURIComponent(filterId));
            }
            
            // add 'selected' state to filter option in dropdown
            chosenFilterElement.classList.add("selected");

            // create new filter chip
            let newSelectionElement = document.createElement("div");
            newSelectionElement.classList.add("selection");
            newSelectionElement.setAttribute("data-id", filterId)
            newSelectionElement.innerHTML = `${chosenFilterElement.innerText}<span class="remove">✕</div>`;

            // add deselect filter event listener
            newSelectionElement.addEventListener("click", (event) => {
                deselectFilter(filterId, categoryId)
            });

            // add new filter to selections
            filterSelections.prepend(newSelectionElement);

            // updateFilterStatus();
            let updateProjectsFilter = categoryId === "companies" ? true : false;
            getData(false, updateProjectsFilter);
        }

        let clearSearch = (categoryId) => {
            let search = document.querySelector(`.filter-wrap .selector[data-id="${categoryId}"] .filter-search`);
            if(!search) return;
            
            search.value = '';

            //simulate input event for search to trigger event listener
            let event = document.createEvent('Event');
            event.initEvent('input', true, true);
            search.dispatchEvent(event);
        }

        let filterEventListeners = () => {
            let allSelectors = document.querySelectorAll(".filter-wrap .selector");

            allSelectors.forEach(selector => {
                let categoryId = selector.getAttribute("data-id");
                let search = selector.querySelector(".filter-search");

                selector.querySelector(".filter-name").addEventListener("click", () => {
                    closeAllSelectors(categoryId);
                    if(selector.classList.contains("active")) {
                        selector.classList.remove("active");
                    }else {
                        clearSearch(categoryId);
                        selector.classList.add("active");
                    }
                })

                let options = selector.querySelectorAll(".filter-options .option");

                options.forEach(option => {
                    option.addEventListener("click", () => {
                        toggleFilter(option, categoryId);
                    })
                })

                // add filter search
                if(search) {
                    search.addEventListener("input", (event) => {   
                        let results = false;               
                        
                        options.forEach(option => {
                            let match = option.innerText.toLowerCase().indexOf(event.target.value.toLowerCase());
                            if(match > -1) {
                                option.classList.remove("hide");
                                results = true;
                            } else {
                                option.classList.add("hide");
                            }
                        })

                        let noResults = selector.querySelector(".no-results");
                        results ? noResults.classList.add("hide") : noResults.classList.remove("hide");
                    })
                };
            })

            nodes.filterSettings.addEventListener("click", (event) => {
                if(!event.target.classList.contains('selector') && !event.target.classList.contains('filter-name') && !event.target.classList.contains('filter-search')) {
                    closeAllSelectors();
                }
            })            
        }

        let populateFilters = (data) => {
            let output = '';

            Object.keys(data).forEach(key => {
                if(data[key] && data[key].length) {
                    let options = data[key];
                    let isSearchable = options.length > 6 ? true : false;

                    let filterOptions = options.map(option => {
                        let name;
                        if(key === 'triggers') {
                            let surveyPeriod = option.name || "Project Status";
                            let status = option.status;
                            name = `${surveyPeriod} - ${status}`;
                        } else {
                            name = option.name || option.first_name + " " + option.last_name
                        }
                        
                        let id = option.id
                        return `<div class="option" data-id="${id}">${utilities.sanitizeData(name)}</div>`
                    }).join('')

                    let search = isSearchable ? `
                        <div class="search-wrap">
                        <input class='filter-search' type="text" placeholder="Search ${filterNameMapping[key].plural}">
                    </div>` : '';

                    output += `
                        <div class="filter-wrap" data-type="${isSearchable ? 'search' : null}" data-id="${key}">
                            <div class="selector" data-id="${key}">
                                <div class="filter-name">
                                    ${filterNameMapping[key].singular}
                                </div>
                                <div class="filter-options">
                                    ${search}
                                    <div class="options-wrap">
                                        ${filterOptions}
                                    </div>
                                    <p class="no-results hide">No results found</p>
                                </div>
                            </div>
                            <div class="selections"><div class="selection all">All ${filterNameMapping[key].plural}</div></div>
                        </div>
                    `
                }
            })

            nodes.filterSettings.querySelector(".all-filters").innerHTML = output;

            filterEventListeners();
            setSettingsHeight();
        }

        let getData = async (buildFilters, updateProjectsFilter, callback) => {
            loadingScreen.reset();
            nodes.loaderElement.classList.remove("disabled");
            loadingScreen.startLoading(15);

            let response = await fetch(urls['projects:responses_data'](currentSurvey), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(queryParams)
            })

            let data = await response.json();

            // update this with proper global flag from backend
            isGlobal = data.filter_options.companies ? true : false;

            if(buildFilters) {
                populateFilters(data.filter_options);
                populateTableHeader(data.categories);
            }

            populateKeyMetrics(data.key_metrics);

            setTimeout(() => {
                setSettingsHeight(true);
                metrics.adjustMetricsHeight();
            }, 100);

            // update global score card title
            let projectScoreCardTitle = nodes.globalMetrics.querySelector(".project-score .card__title");
            projectScoreCardTitle.innerText = isGlobal ? "Overall Template Score" : "Overall Project Score";

            populateCategoryMetrics(data.categories);
            pagination.set(data.page_info);

            if(!data.responses.length) {
                nodes.tableResultsWrap.classList.add("hide");
                nodes.noResultsWrapper.classList.remove("hide");
            } else {
                populateResponses(data.responses);
                nodes.tableResultsWrap.classList.remove("hide");
                nodes.noResultsWrapper.classList.add("hide");
            }

            browser_storage.setItem("last-visited-survey", currentSurvey);

            if(callback) callback();

            nodes.loaderElement.classList.add("disabled");
            loadingScreen.loadFinish();
        }

        let createEventListeners = () => {
            nodes.responsesHeader.addEventListener("click", () => {
                nodes.filterSettingsToggle.classList.contains("active") ? nodes.filterSettingsToggle.classList.remove("active") : nodes.filterSettingsToggle.classList.add("active");
                
                if(nodes.filterSettings.classList.contains("hide")) {
                    nodes.filterSettings.classList.remove("hide");
                    nodes.filterSettingsToggleLabel.innerText = "Hide Filters";
                } else {
                    nodes.filterSettings.classList.add("hide");
                    nodes.filterSettingsToggleLabel.innerText = "Show Filters";
                }
            })

            nodes.globalMetricsHeader.addEventListener("click", (event) => {
                if(browser_storage.getItem("survey-results-stats-collapse") === "false") {
                    browser_storage.setItem("survey-results-stats-collapse", "true");
                    nodes.globalMetrics.classList.add("collapse");
                } else {
                    browser_storage.setItem("survey-results-stats-collapse", "false");
                    nodes.globalMetrics.classList.remove("collapse");
                }
            })

            nodes.filtersReset.addEventListener("click", () => {
                queryParams = JSON.parse(JSON.stringify(initialQueryParams));

                document.querySelectorAll(".selection:not(.all)").forEach(selection => {
                    selection.parentElement.querySelector(".all").classList.remove("hide");
                    selection.remove();
                })

                document.querySelectorAll(".option.selected").forEach(option => {
                    option.classList.remove("selected");
                })

                getData();
            })
        }

        const csvDownload = () => {
            const classes = {
                CSV: {
                    btn: ".csv-download",
                    filter: ".nps-csv-download-filters_js",
                    noFilter: ".nps-csv-download-no-filters_js",
                    modalContent: ".modal-template-csv_js"
                },
            };
            //button for download csv modal
            const downloadCSVBtn = document.querySelector(classes.CSV.btn);

            downloadCSVBtn.addEventListener("click", function () {
                const content = document.querySelector(classes.CSV.modalContent);
                const title = content.getAttribute("data-title");
                const className = content.getAttribute("data-class");

                createdModal.open({
                    //set a wrap class for a modal
                    class: className,
                    //set content for a modal
                    content: content.innerHTML,
                    //set title for a modal
                    title: title
                }, () => {
                    //Bind events when DOM loaded at the modal screen;
                    let downloadFilter = document.querySelector(classes.CSV.filter);
                    let downloadNoFilter = document.querySelector(classes.CSV.noFilter);
                    downloadFilter.addEventListener("click", downloadCSV);
                    downloadNoFilter.addEventListener("click", downloadCSV);
                });
            });

            //function that called when you click how you want to download CSV
            const downloadCSV = async (event) => {
                const url = urls['projects:responses_csv'](currentSurvey);

                try {
                    $.ajax({
                        url: url,
                        type: 'POST',
                        contentType: "application/json; charset=utf-8",
                        data: JSON.stringify(event.target.getAttribute("data-all") ? initialQueryParams : queryParams)
                    }).done((data) => {
                        let blob = new Blob([data], {type: 'text/csv'});
                        let date = new Date()
                        let filename = `Project Survey Results - SmileBack - ${date.toISOString().split('T')[0]}`;
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                            window.navigator.msSaveOrOpenBlob(blob, filename);
                        } else {
                            let link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = filename;
                            link.click();
                        }
                    });

                } catch (error) {
                    console.error(error.message);
                }
                createdModal.close();
            }
        }
        return {
            init: function () {

                automationBanner();
                csvDownload();

                if(browser_storage.getItem("survey-results-stats-collapse") === "false") {
                    nodes.globalMetrics.classList.add("no-transition");
                    nodes.globalMetrics.classList.remove("collapse");
                    nodes.globalMetrics.classList.remove("no-transition");
                }

                // check for active surveys
                if(nodes.surveySelectorOptions.length) {
                    let DDSurveySelector = DD(nodes.surveySelector, (value) => {
                        currentSurvey = value;
                        queryParams = JSON.parse(JSON.stringify(initialQueryParams));
                        searchField.reset();
                        getData(true);
                    });

                    // check for survey ID in url
                    let passedID = utilities.getQueryStringVariable("id");
                    // get last visited survey or first survey in list
                    currentSurvey = passedID ? passedID : browser_storage.getItem("last-visited-survey");

                    let surveyExists = false;
                    // check if saved survey still exists
                    nodes.surveySelectorOptions.forEach(option => {
                        if(option.value === currentSurvey) {
                            surveyExists = true;
                        }
                    })

                    if(currentSurvey && currentSurvey.length && surveyExists) {
                        getData(true);
                        DDSurveySelector.chooseOption(currentSurvey);
                    } else {
                        currentSurvey = nodes.surveySelectorOptions[0].value;
                        getData(true);
                    }

                    //init Pagination
                    pagination = initPagination(nodes.pagination, function (value) {
                        queryParams.page = value;
                        getData();
                    }, queryParams);

                    let releaseSearch = () => {
                        nodes.searchField.searchField.disabled = false;
                        nodes.searchField.searchField.focus();
                    }

                    let searchField = initSearchField(nodes.searchField, function (value) {
                        nodes.searchField.searchField.disabled = true;
                        queryParams["q"] = customEncodeUri(value);
                        
                        queryParams.page = 1;
                        getData(false, false, () => {
                            releaseSearch();
                        });

                    }, {next: queryParams.q});

                    let limitNode = document.querySelector(".nps-responses-custom-limit_js");
                    limitNode.querySelector("select").value = queryParams.limit + "";

                    let DDReset = DD(limitNode, (value) => {
                        queryParams["limit"] = value;
                        queryParams.page = 1;
                        getData();
                    });
                } else {
                    nodes.noSurveysWrap.classList.remove("hide");
                }                

                createEventListeners();
            }
        }
    }
);